<template>
  <div class="mt-2 mb-3">
    <div class="d-flex justify-content-between">
      <h2 class="fw-light d-flex align-items-center mb-0">
        Contratos à Vencer
      </h2>
      <router-link
        to="/documents/suppliers"
        class="btn btn-success rounded-pill"
        title="Gerenciar Fornecedores"
      >
        Gerenciar Fornecedores
      </router-link>
    </div>
  </div>
  <LoadingData v-if="isLoading" />
  <DataTableDefault v-else :dataTable="dataTable" :options="optionsDataTable" />
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import DataTableDefault from '@/components/commons/DataTableDefault.vue'
import { formatToCurrencyBr } from '@/utils/currency'
import { contractExpirationDate } from '@/utils/date'

export default {
  name: 'ContractsToExpire',

  components: {
    LoadingData,
    DataTableDefault,
  },

  data() {
    return {
      isLoading: true,
      path: process.env.VUE_APP_BASE_URL,
      dataTable: {
        columns: [
          {
            data: 'nomeContrato',
            title: 'Contrato',
          },
          {
            data: 'fornecedor',
            title: 'Cliente',
          },
          {
            data: 'saldo',
            title: 'Saldo',
          },
          {
            data: 'dataFim',
            title: 'Vencimento',
          },
          {
            data: 'idContrato',
            title: 'Ações',
            searchable: false,
            orderable: false,
            render(value) {
              return `
              <a href="#" data-item-router="/documents/contracts" data-item-id="${value}" class="badge bg-primary" title="Detalhar">
                Detalhar
              </a>`
            },
          },
        ],
        data: [],
      },
      optionsDataTable: {
        columnDefs: [{ targets: [4], className: 'text-center' }],
      },
    }
  },

  methods: {
    async getDocumentsToExpire() {
      try {
        const contracts = await this.$store.dispatch('getDocumentsToExpire')

        this.dataTable.data = contracts.map((contract) => {
          return {
            nomeContrato: contract.nomeContrato,
            fornecedor: contract.fornecedor,
            saldo: formatToCurrencyBr(contract.saldo),
            dataFim: contractExpirationDate(contract.dataFim),
            idContrato: contract.idContrato,
          }
        })

        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getDocumentsToExpire()
  },
}
</script>
